import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './transactiontype-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import ReportgroupPicklist from '../reportgroup/reportgroup-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactiontypeEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadReportgroup = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'reportgroup': data?.id, 'reportgroupCaption': data?.name || ''  }  });
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
        
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} 
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                }     
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} error={this.state.errors?.type} onChange={this.onChange} />
                <InputSelect name='pricetype' label='Use Price' value={this.state.datarow.pricetype} options={Model.optionPricetype} error={this.state.errors?.pricetype} onChange={this.onChange} />
                <InputPicklist name='reportgroup' label='Report Group' value={this.state.datarow.reportgroup} caption={this.state.datarow.reportgroupCaption} clearValue={this.onLoadReportgroup} error={this.state.errors?.reportgroup} onChange={this.onChange}>
                    <ReportgroupPicklist currentId={this.state.datarow.reportgroup} onLoad={this.onLoadReportgroup}/>
                </InputPicklist>

            </BaseEdit>
        );
    }
}